let calendar, eventDate;
const localeCalendar = {
    ru: {
        weekdays: {
            shorthand: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
            longhand: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
        },
        months: {
            shorthand: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            longhand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        },
    },
    ua: {
        weekdays: {
            shorthand: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
            longhand: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П\'ятниця', 'Субота'],
        },
        months: {
            shorthand: ['Сiч', 'Лют', 'Бер', 'Квіт', 'Трав', 'Черв', 'Лип', 'Серп', 'Вер', 'Жовт', 'Лист', 'Груд'],
            longhand: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
        },
    },
    en: {
        weekdays: {
            shorthand: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            longhand: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        },
        months: {
            shorthand: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            longhand: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        },
    }
};

function getPickrData(date = new Date()) {
    return flatpickr.formatDate(date, "d F Y")
}

function compareDates(first, second) {
    return getDate(first) == getDate(second);
}

function getDate(date) {
    var current = new Date(date);
    return current.getFullYear() + '.' + (current.getMonth() + 1) + '.' + (current.getDate() + 1);   // Y-m-d H:i:s
}

function calendarInit() {
    calendar = eventDate.flatpickr({
        dateFormat: "d F Y",
        altFormat: "d F Y",
        altInput: true,
        mode: "range",
        showMonths: device.mobile() ? 1 : 2,
        minDate: "today",
        disableMobile: "true",
        clickOpens: "false",
        enableTime: true,
        defaultDate: new Date(),
        appendTo: window.document.querySelector('.calendar-wrap'),
        onOpen: () => {
            /*if (mobile) {
                scrollTo(".orderForm", eventDate.closest('.row').position().top, 0)
            }*/
        },
        onReady: () => {
            let dateInfo = $(".calendar-bottom");
            $(".flatpickr-days").after(dateInfo);
            // $(this).find(".flatpickr-days").after(dateInfo);

            // indent dates
        },
        onChange: function (dates) {
            if (dates.length == 2) {
                let dateShort = dates.map(date => this.formatDate(date, "d.m.y"));
                let dateValid = dates.map(date => this.formatDate(date, "Y-m-d"));
               let dateArr = dates.map(date => this.formatDate(date, "d F Y"));
               $(".calendar-bottom p").text(dateArr[0] + " - " + dateArr[1]);
               $(".choose-date input[name=event-date]").val(dateValid[0] + "," + dateValid[1]);
               $(".active-dates").show();
               $(".active-dates p span").text(dateShort[0] + " - " + dateShort[1]);

            }
        },

        locale: {
            firstDayOfWeek: 1,
            weekdays: {
                shorthand: localeCalendar[lang].weekdays.shorthand,
                longhand: localeCalendar[lang].weekdays.longhand,
            },
            months: {
                shorthand: localeCalendar[lang].months.shorthand,
                longhand: localeCalendar[lang].months.longhand,
            },
        },
    });
}

$(document).ready(function () {
    eventDate = $(".choose-date input[name=event-date]");

    if (eventDate.length) {
        calendarInit()
    }

    $(document).on("click", ".choose-date", function () {
        calendar.open();
    });
    $(document).on("click", ".active-dates p button", function () {
        $(".active-dates p span").text("");
        $(".active-dates").hide();
        calendar.clear();
    });
});